<template>
  <div class="noAccount" :class="{invert}">
    <div class="title">{{ $t("noAccount.no_account") }}</div>
    <div class="description" v-html="$t('noAccount.no_account_text').replace('%replace%',$store.state.cogir ? 'Octopus' : 'Humaniti')"></div>
    <div class="buttons">
      <div class="btn btn-secondary" @click="back">{{ $t("navigation.back") }}</div>
      <div class="btn btn-primary" @click="login">{{ $t("noAccount.login") }}</div>
    </div>
  </div>
</template>

<script>

  export default {

    name: "noAccount",

    props: {
      invert: Boolean
    },

    methods: {
      back() {
        window.history.back();
      },
      login() {
        this.$router.push("/login");
      }
    }

  }

</script>

<style lang="scss" scoped>

  .noAccount {
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 30px;
    &.invert {
      color: white;
      .title {
        color: #f2f3f4;
      }
    }
  }

  .title {
    font-size: 40px;
    color: #405159;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 60px;
    &:after {
      content: "";
      display: block;
      background-color: #bfc5c8;
      height: 5px;
      width: 60px;
      left: 50%;
      bottom: -28px;
      transform: translateX(-50%);
      position: relative;
    }
  }

  .buttons {
    margin-top: 30px;
    display: flex;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  /* DESKTOP ONLY RULES */
  @media screen and (min-width: 601px) {
    .noAccount {
      background-color: white;
      border-radius:2px;
      padding: 30px 40px;
      max-width: 550px;
      .buttons{
        margin: 30px 10px 0 10px;
        
        justify-content: space-between;
        .btn {
          flex-grow:0;
          min-width:180px;
        }
      }
    }
  }

</style>